<div class="admin-home-purchases h-full w-full flex flex-col p-4 min-h-0 gap-4">
  <fieldset class="purchases-groupbox purchases-section purchases-filters w-full flex-shrink-0">
    <legend>{{ 'common.filters' | translate | ucfirst }}</legend>

    <form
      *ngIf="form"
      [formGroup]="form"
      class="purchases-filters-form"
    >
      <div class="purchases-filters-form__row purchases-filters-form__row--primary">
        <dx-text-box
          formControlName="purchaseOrder"
          formField
          class="purchases-filters-form__field"
          [label]="'common.tabTitle.purchaseOrders' | translate | ucfirst"
        />
        <dx-text-box
          formControlName="deliveryNote"
          formField
          class="purchases-filters-form__field"
          [label]="'entity.deliveryNoteLine.deliveryNoteReference' | translate | ucfirst"
        />
        <dx-lookup
          formControlName="productId"
          formField
          class="purchases-filters-form__field"
          [label]="'entity.product.product' | translate | ucfirst"
          [gsResource]="productsResource"
          displayExpr="name"
          valueExpr="id"
          itemTemplate="productItemTpl"
        >
          <div *dxTemplate="let item of 'productItemTpl'">
            <div *ngIf="item">
              <div class="font-bold">{{ item.code }}</div>
              <div class="text-wrap">{{ item.name }}</div>
            </div>
          </div>
        </dx-lookup>
        <dx-date-box
          formControlName="startDate"
          formField
          class="purchases-filters-form__field"
          [label]="'home.purchaseOrders.startDate' | translate | ucfirst"
        />
        <dx-date-box
          formControlName="endDate"
          formField
          [label]="'home.purchaseOrders.endDate' | translate | ucfirst"
          class="purchases-filters-form__field"
        />
      </div>

      <div class="purchases-filters-form__row purchases-filters-form__row--secondary">
        <dx-lookup
          formControlName="providerId"
          formField
          class="purchases-filters-form__field"
          [label]="'home.purchaseOrders.supplier' | translate | ucfirst"
          [gsResource]="providersResource"
          displayExpr="legalName"
          valueExpr="id"
        />
        <dx-tag-box
          formControlName="orderStates"
          formField
          class="purchases-filters-form__field"
          [label]="'home.purchaseOrders.states' | translate | ucfirst"
          [items]="orderStates"
          valueExpr="name"
          displayExpr="name"
        />
        <dx-tag-box
          formControlName="lineStates"
          formField
          class="purchases-filters-form__field"
          [label]="'home.purchaseOrders.lineStates' | translate | ucfirst"
          [items]="lineStates"
          valueExpr="id"
          displayExpr="name"
        />
        <dx-date-box
          formControlName="startDeliveryDate"
          formField
          class="purchases-filters-form__field"
          [label]="'home.purchaseOrders.startDeliveryDate' | translate | ucfirst"
        />
        <dx-date-box
          formControlName="endDeliveryDate"
          formField
          class="purchases-filters-form__field"
          [label]="'home.purchaseOrders.endDeliveryDate' | translate | ucfirst"
        />
      </div>
    </form>
  </fieldset>

  <fieldset *ngIf="breadCrumbVisible" class="purchases-groupbox purchases-section purchases-breadcrumb w-full flex-shrink-0">
    <legend>{{ 'common.breadcrumb' | translate | ucfirst }}</legend>

    <div class="purchases-groupbox__content">
      <gs-level-breadcrumb
        [levels]="breadcrumbLevels"
        [itemTemplates]="levelItemTemplates"
        [fieldTemplates]="levelFieldTemplates"
        (selectionChange)="onBreadcrumbChange($event)"
      />
    </div>

    <ng-template #projectItemTpl let-item>
      <div *ngIf="item">
        <div class="font-bold">{{ item.number }}</div>
        <div class="text-wrap">{{ item.name }}</div>
      </div>
    </ng-template>
    <ng-template #projectFieldTpl let-item>
      <div *ngIf="item">
        <div class="font-bold">{{ item.number }}</div>
        <div class="text-wrap">{{ item.name }}</div>
      </div>
    </ng-template>
    <ng-template #budgetDistItemTpl let-item>
      <div *ngIf="item">
        <div class="font-bold">{{ item.code }}</div>
        <div class="text-wrap">{{ item.name }}</div>
      </div>
    </ng-template>
    <ng-template #budgetDistFieldTpl let-item>
      <div *ngIf="item">
        <div class="font-bold">{{ item.code }}</div>
        <div class="text-wrap">{{ item.name }}</div>
      </div>
    </ng-template>
  </fieldset>

  <fieldset class="purchases-groupbox purchases-groupbox--results purchases-section w-full flex-1 min-h-0">
    <legend>{{ 'common.results' | translate | ucfirst }}</legend>

    <div class="purchases-results-content">
      <gs-paginated-card-list
        class="purchases-card-list w-full flex-1 min-h-0 block"
        #cardList
        [resource]="homePurchaseOrderLinesResource"
        [backendFilters]="listQueryParams"
        (itemClick)="openPurchaseOrder($event)"
      >
        <ng-template let-line>
          <div class="purchase-card w-full border p-4 cursor-pointer overflow-x-hidden">
            <div class="purchase-card-header">
              <div class="uppercase font-bold purchase-card__title">{{ line.purchaseOrderNumber }}</div>
              <div class="mb-1">{{ 'home.purchaseOrders.documentTypeName' | translate | ucfirst }}: {{ line.documentTypeName }}</div>
              <div class="mb-1">{{ 'home.purchaseOrders.documentDate' | translate | ucfirst }}: {{ line.documentDate | date:'dd/MM/yyyy' }}</div>
              <div class="mb-1">{{ 'home.purchaseOrders.organizationLegalName' | translate | ucfirst }}: {{ line.organizationLegalName }}</div>
              <div *ngIf="line.organizationTradeName !== line.organizationLegalName" class="mb-1">{{ 'home.purchaseOrders.organizationTradeName' | translate | ucfirst }}: {{ line.organizationTradeName }}</div>
              <div class="mb-1">{{ 'home.purchaseOrders.deliveryAddress' | translate | ucfirst }}: {{ line.deliveryAddress }}</div>
              <div class="mb-1">{{ 'home.purchaseOrders.documentTypeStateName' | translate | ucfirst }}: {{ line.documentTypeStateName }}</div>
              <div class="mb-1">{{ 'home.purchaseOrders.orderAmount' | translate | ucfirst }}: {{ line.orderAmount | currency:getCurrencySymbol(line):'symbol':getCurrencyDigitsInfo(line):langCode }}</div>
            </div>
            <div class="purchase-card-line">
              <div class="mb-1">{{ 'home.purchaseOrderProducts.lineCode' | translate | ucfirst }}: {{ line.lineCode }}</div>
              <div class="mb-1">{{ 'home.purchaseOrderProducts.lineDescription' | translate | ucfirst }}: {{ line.lineDescription }}</div>
              <div class="mb-1">{{ 'home.purchaseOrderProducts.lineTotalQuantity' | translate | ucfirst }}: {{ line.lineTotalQuantity }}</div>
              <div class="mb-1">{{ 'home.purchaseOrderProducts.linePendingQuantity' | translate | ucfirst }}: {{ line.linePendingQuantity }}</div>
              <div class="mb-1">{{ 'home.purchaseOrderProducts.lineNetAmount' | translate | ucfirst }}: {{ line.lineNetAmount | currency:getCurrencySymbol(line):'symbol':getCurrencyDigitsInfo(line):langCode }}</div>
              <div class="mb-1">{{ 'home.purchaseOrderProducts.lineExpectedDate' | translate | ucfirst }}: {{ line.lineExpectedDate | date:'dd/MM/yyyy' }}</div>
              <div class="mb-1">{{ 'home.purchaseOrderProducts.projectBudgetDistributions' | translate | ucfirst }}: {{ line.projectBudgetDistributions }}</div>
              <div class="mb-1">{{ 'home.purchaseOrderProducts.batchNumbers' | translate | ucfirst }}: {{ line.batchNumbers }}</div>
            </div>
          </div>
        </ng-template>
      </gs-paginated-card-list>
    </div>
  </fieldset>
</div>
